import { Table, TableColumnsType } from 'antd';
import React from 'react';
import { FormatDate } from '../../../constants';
import { ArchivedCaseSummaryActivityLog } from '../../../generated';
export interface ActivityLogLiteProps {
  data: ArchivedCaseSummaryActivityLog[];
}

export const ActivityLogLite: React.FC<ActivityLogLiteProps> = (props) => {
  const sortedLogs = [...(props.data ?? [])].sort((a, b) => new Date(b?.updatedAt).getTime() - new Date(a?.updatedAt).getTime());
  let index = 0;
  // modify the data to add an id field
  const modifiedData = sortedLogs.map((item) => {
    return {
      ...item,
      id: index++
    };
  });

  const columns: TableColumnsType<ArchivedCaseSummaryActivityLog> = [
    {
      title: 'Activity',
      dataIndex: 'activityType',
      key: 'activityType',
      render: (text: string) => (text === 'INPROGRESS' ? 'In Progress' : text)
    },
    {
      title: 'Tags',
      dataIndex: 'tags',
      key: 'tags',
      render: (tags: string[]) => tags.join(', ')
    },
    {
      title: 'Activity By',
      dataIndex: ['activityBy', 'displayName'],
      key: 'activityBy',
      render: (text: string) => text ?? 'SYSTEM'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'activityDescription'
    },
    {
      title: 'Date',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text: any) => <span>{FormatDate(text)}</span>,
      sorter: (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    }
  ];

  const ActivityTable: React.FC<{
    data: ArchivedCaseSummaryActivityLog[];
  }> = ({ data }) => (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(record: any) => record.id}
      pagination={false}
      scroll={{
        y: 400 // Adjust the height for vertical scrolling
      }}
    />
  );

  return (
    <div
      style={{
        width: '100%',
        height: '20%',
        marginTop: 10,
        padding: 10
      }}
    >
      <ActivityTable data={modifiedData} />
    </div>
  );
};
